var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarsPen({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.625 7.6665L8.41667 10.5832L11.3333 5.37484L8.41667 0.166504L13.625 3.08317L18.8333 0.166504L15.9167 5.37484L18.8333 10.5832L13.625 7.6665ZM38.625 28.0832L43.8333 25.1665L40.9167 30.3748L43.8333 35.5832L38.625 32.6665L33.4167 35.5832L36.3333 30.3748L33.4167 25.1665L38.625 28.0832ZM43.8333 0.166504L40.9167 5.37484L43.8333 10.5832L38.625 7.6665L33.4167 10.5832L36.3333 5.37484L33.4167 0.166504L38.625 3.08317L43.8333 0.166504ZM25.7917 22.6248L30.875 17.5415L26.4583 13.1248L21.375 18.2082L25.7917 22.6248ZM27.9375 11.1873L32.8125 16.0623C33.625 16.8332 33.625 18.1873 32.8125 18.9998L8.5 43.3123C7.6875 44.1248 6.33333 44.1248 5.5625 43.3123L0.6875 38.4373C-0.125 37.6665 -0.125 36.3123 0.6875 35.4998L25 11.1873C25.8125 10.3748 27.1667 10.3748 27.9375 11.1873Z",
    fill: "#F61584"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarsPen);
export default __webpack_public_path__ + "static/media/starsPen.eef92b0ad4c176019fe56540fbd0eb63.svg";
export { ForwardRef as ReactComponent };